import { useState } from "react";
import { Link } from "react-router-dom";
import { Coins, Gift, Users, TrendingUp, Star, Ticket, CalendarHeart, UserPlus } from "lucide-react";
import { AnimatedEmblem } from "../shop/AnimatedEmblem";
import { CardBackArt } from "../shop/CardBackArt";
import { useLang } from "../../context/LangContext";
import { TrustRow } from "../security/TwoFactor";

export const Perks = ({ dark = true }) => {
  const { tr } = useLang();
  const perks = [[Coins, tr("Jolgen Punkte sammeln", "Earn Jolgen Points")], [Gift, tr("Exklusive Member-Deals", "Exclusive member deals")], [Users, tr("Community & Giveaways", "Community & giveaways")], [TrendingUp, tr("Level up deine Sammlung", "Level up your collection")]];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {perks.map(([Icon, l]) => (
        <div key={l} className="text-center space-y-2">
          <span className="mx-auto h-12 w-12 rounded-2xl grid place-items-center bg-[#8A5CD6]/20 border border-[#8A5CD6]/40"><Icon className="h-5 w-5 text-[#F2C230]" /></span>
          <p className={`text-xs leading-tight ${dark ? "text-white/80" : "text-[#120E1F]"}`}>{l}</p>
        </div>
      ))}
    </div>
  );
};

export const JoinHero = ({ onStart }) => {
  const { tr } = useLang();
  return (
    <section className="bg-[#120E1F] grain relative overflow-hidden" data-testid="join-hero">
      <div className="psychic-glow float absolute -top-32 left-1/2 -ml-[320px] h-[640px] w-[640px] rounded-full" />
      <div className="volt-glow absolute bottom-0 right-0 h-96 w-96 rounded-full" />
      {[[-14, "left-[6%] top-16"], [12, "right-[7%] top-24"], [-6, "left-[14%] bottom-10"], [9, "right-[15%] bottom-16"]].map(([r, pos]) => (
        <div key={pos} className={`hidden md:block absolute ${pos} h-44 w-32 float`}><div className="relative h-full w-full"><CardBackArt tilt={r} bare /></div></div>
      ))}
      <div className="relative max-w-3xl mx-auto px-4 py-20 sm:py-28 text-center space-y-8">
        <AnimatedEmblem className="h-28 w-28 sm:h-36 sm:w-36 mx-auto" testid="join-hero-emblem" />
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.02]">{tr("Werde Teil der", "Join the")}<br /><span className="text-gold-grad">Jolgen Cards</span> Community</h1>
        <p className="text-white/70 text-base sm:text-lg">{tr("Sammeln. Tauschen. Punkte verdienen. Teil von etwas Besonderem sein.", "Collect. Trade. Earn. Be part of something special.")}</p>
        <Perks />
        <div className="space-y-3">
          <TrustRow dark />
          <button onClick={onStart} className="btn-gold w-full sm:w-auto sm:px-12 h-12" data-testid="join-start-btn">{tr("Konto erstellen", "Create your account")}</button>
          <p className="text-sm text-white/60">{tr("Schon Mitglied?", "Already a member?")} <Link to="/login" className="text-[#C9B6F2] underline underline-offset-4" data-testid="join-signin-link">{tr("Anmelden", "Sign in")}</Link></p>
        </div>
      </div>
    </section>
  );
};

export const EARN_WAYS = [
  ["signup", UserPlus, "Konto erstellen", "Create an account", "+200"],
  ["profile", Star, "Profil vervollständigen", "Complete your profile", "+100"],
  ["order", Ticket, "Bestellung aufgeben", "Place an order", "+10 / 1 €"],
  ["review", Star, "Produkt bewerten", "Write a product review", "+100"],
  ["collection", Coins, "Karte zur Sammlung hinzufügen", "Add a card to your collection", "+20"],
  ["post", Users, "Community-Beitrag teilen", "Share a community post", "+20"],
  ["birthday", CalendarHeart, "Geburtstag feiern", "Celebrate your birthday", "+500"],
  ["referral", UserPlus, "Freund:in einladen", "Refer a friend", "+300"],
];

export const useCopy = () => {
  const [copied, setCopied] = useState(false);
  const copy = (txt) => { navigator.clipboard.writeText(txt); setCopied(true); setTimeout(() => setCopied(false), 1500); };
  return [copied, copy];
};
